import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-aa150532"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Assign a licence", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-primary mr-2",
  "data-test": "assign-licence-submit"
}, " Submit ", -1))
const _hoisted_4 = {
  key: 0,
  class: "text-danger mt-2"
}

import { Modal } from "uiv";
import { computed, ref } from "vue";
import axios, { AxiosError } from "axios";


export default /*#__PURE__*/_defineComponent({
  __name: 'assign-licence-dialog',
  props: {
    modelValue: { type: Boolean },
    memberId: {}
  },
  emits: ["toggle-assign-licence-modal", "update-licences"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const displayModal = computed(() => {
  return props.modelValue;
});

const licenceError = ref<string | null>(null);

async function assignLicenceForMember(): Promise<void> {
  licenceError.value = null;
  try {
    const response = await axios.post(`/api/admin/assignlicence/${props.memberId}`);
    if (response.status === 200) {
      emit("toggle-assign-licence-modal");
      emit("update-licences");
    }
  } catch (err) {
    const error = err as AxiosError;
    licenceError.value = error.response?.status.toString().startsWith("4")
      ? error.response?.data
      : "There was an error assigning this licence.";
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal), {
    modelValue: displayModal.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((displayModal).value = $event)),
    footer: false,
    header: false
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("form", {
        onSubmit: _withModifiers(assignLicenceForMember, ["prevent"]),
        class: "modal-form"
      }, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('toggle-assign-licence-modal'))),
          class: "btn btn-default"
        }, " Cancel ")
      ], 32),
      (licenceError.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Error: " + _toDisplayString(licenceError.value), 1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})